import PotdListing from './PotdListing';

export default PotdListing;
